"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'login.form.title': 'Login',
    'login.form.hero.title': 'Lorem ipsum dolor',
    'login.form.hero.description': 'Please use your credentials to log in.',
    'login.form.hero.register_link_text': 'If you are not a member, please',
    'login.form.hero.register_link': 'register here',
};
